import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Actions from '../../../../actions'
import Dialog from '../../../common/Dialog'
import leave from '../../../../resources/leave.png'

const RiskAssessmentExitDialog = () => {
  const dispatch = useDispatch()
  const shouldDisplayTerminateBotAlert = useSelector(
    state => state.getCare.shouldDisplayTerminateRiskAssessmentAlert
  )

  const closeTerminateBotAlert = () => {
    dispatch(
      Actions.createAction(Actions.TERMINATE_RISK_ASSESSMENT_POPUP, {
        isVisible: false,
      })
    )
  }
  const onExitBot = () =>
    dispatch(Actions.createAction(Actions.BOT_WIZARD_CLOSED))

  return (
    <Dialog
      closable={true}
      image={leave}
      title={$t('dialogs.riskAssessmentCloseBot.title')}
      isVisible={shouldDisplayTerminateBotAlert}
      onCancel={closeTerminateBotAlert}
      footerActions={[
        <Button
          key="2"
          className="dialog-action trackable"
          data-name="back to form"
          onClick={closeTerminateBotAlert}
          type="primary"
        >
          {$t('dialogs.riskAssessmentCloseBot.backForm')}
        </Button>,
        <Button
          key="1"
          className="dialog-action trackable"
          data-name="exit bot"
          onClick={() => {
            onExitBot()
            closeTerminateBotAlert()
          }}
        >
          {$t('dialogs.riskAssessmentCloseBot.exit')}
        </Button>,
      ]}
    >
      <div>{$t('dialogs.riskAssessmentCloseBot.subtitle')}</div>
    </Dialog>
  )
}

export default RiskAssessmentExitDialog
